import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: {
                calendar: {
                    url: '/courses/{{year}}/{{month}}',
                    available_one: '{{count}} available place',
                    available_other: '{{count}} available places',
                    available_zero: 'Full',
                },
                cart: {
                    soldOut: 'Sold out',
                    lastSpot: 'Last spot',
                    availableTickets: '{{count}} tickets available',
                    confirmRemove: 'Are you sure you want to remove this item?',
                    subtotal: 'Subtotal',
                    vat: 'VAT (incl.)',
                    total: 'Total',
                    checkout: 'Checkout',
                    empty: 'Your cart is empty',
                },
                common: {
                    error: 'Something went wrong',
                },
                checkout: {
                    orderSummary: 'Order Summary',
                    personalDetails: 'Personal Details',
                    name: 'Name',
                    email: 'Email',
                    address: 'Address',
                    postalCode: 'Postal Code',
                    city: 'City',
                    country: 'Country',
                    termsAgreement:
                        'I agree to the <privacy>privacy statement</privacy> and the <terms>terms and conditions</terms>',
                    pay: 'Pay',
                    phone: 'Contact person phone number',
                    phoneHelper:
                        'Your phone number is needed for contact and coordination regarding the course.',
                    invalidCountry: 'This country is not available',
                    deposit: 'Deposit',
                    depositInfo:
                        'A minimum deposit of 50% is required for a reservation. The remaining amount can be transferred by bank up to one week before the course. The remainder can also be paid in cash or by card at the start of the course.',
                    backToCart: 'Back to cart',
                },
                countries: {
                    NL: 'Netherlands',
                    BE: 'Belgium',
                    DE: 'Germany',
                    LU: 'Luxembourg',
                    PL: 'Poland',
                    CH: 'Switzerland',
                    AT: 'Austria',
                    FR: 'France',
                    GB: 'United Kingdom',
                    DK: 'Denmark',
                    selectCountry: 'Select country',
                },
                validation: {
                    invalidEmail: 'Invalid email address',
                    nameRequired: 'Name is required',
                    phoneRequired: 'Phone number is required',
                    invalidPhone: 'Invalid phone number',
                    addressRequired: 'Address is required',
                    postalCodeRequired: 'Postal code is required',
                    invalidPostalCode: 'Invalid postal code format. Example: {{example}}',
                    cityRequired: 'City is required',
                    selectCountry: 'Please select a valid country',
                },
                voucher: {
                    types: {
                        Smeedcursussen: 'Forging courses',
                        'Cursus messen maken': 'Knife making course',
                        'Waardebon eigen bedrag': 'Voucher custom amount',
                    },
                    from: 'From',
                    to: 'To',
                    amount: 'Amount',
                    orderVoucher: 'Order Voucher',
                    customAmount: 'Custom amount',
                    selectVoucher: 'Select your voucher',
                    successMessage: 'Voucher successfully added to your cart!',
                    viewCart: 'View Cart',
                    addAnother: 'Add Another Voucher',
                    enterAmount: 'Enter amount',
                    prefix: 'Voucher: {{description}}',
                    noTicketsAvailable: 'No more tickets available',
                    increaseQuantity: 'Increase quantity',
                    description_for_customized_vouchers:
                        'You can buy a voucher for someone else or for yourself. Please fill in the details below.',
                    title: 'Gift Voucher',
                    enterCode: 'Enter voucher code',
                    apply: 'Apply',
                    remove: 'Remove',
                    invalid: 'Invalid voucher code',
                    applied: 'Voucher applied successfully',
                    removed: 'Voucher removed',
                    applyFailed: 'Error applying voucher',
                    removalFailed: 'Error removing voucher',
                },
            },
        },
        nl: {
            translation: {
                calendar: {
                    url: '/cursussen/{{year}}/{{month}}',
                    available_one: '{{count}} vrije plaats',
                    available_other: '{{count}} vrije plaatsen',
                    available_zero: 'Vol',
                },
                cart: {
                    soldOut: 'Uitverkocht',
                    lastSpot: 'Laatste plek',
                    availableTickets: 'Nog {{count}} tickets beschikbaar',
                    confirmRemove: 'Weet je zeker dat je dit item wilt verwijderen?',
                    subtotal: 'Subtotaal',
                    vat: 'BTW (incl.)',
                    total: 'Totaal',
                    checkout: 'Afrekenen',
                    empty: 'Je winkelwagen is leeg',
                },
                common: {
                    error: 'Er is iets misgegaan',
                },
                checkout: {
                    orderSummary: 'Bestelling overzicht',
                    personalDetails: 'Persoonlijke gegevens',
                    name: 'Naam',
                    email: 'E-mailadres',
                    address: 'Adres',
                    postalCode: 'Postcode',
                    city: 'Plaats',
                    country: 'Land',
                    termsAgreement:
                        'Ik ga akkoord met de <privacy>privacy verklaring</privacy> en de <terms>algemene voorwaarden</terms>',
                    pay: 'Betalen',
                    phone: 'Telefoonnummer contactpersoon',
                    phoneHelper:
                        'Uw telefoonnummer is nodig voor contact en afstemming over de cursus.',
                    invalidCountry: 'Dit land is niet toegestaan',
                    deposit: 'Aanbetaling',
                    depositInfo:
                        'Voor een reservering is minimaal een aanbetaling van 50% vereist. Het resterende bedrag kan tot een week voor de tijd per bank worden overgemaakt. Ook kan het restant contact of per pin bij aanvang van de cursus betaald worden.',
                    backToCart: 'Terug naar winkelwagen',
                },
                countries: {
                    NL: 'Nederland',
                    BE: 'België',
                    DE: 'Duitsland',
                    LU: 'Luxemburg',
                    PL: 'Polen',
                    CH: 'Zwitserland',
                    AT: 'Oostenrijk',
                    FR: 'Frankrijk',
                    GB: 'Verenigd Koninkrijk',
                    DK: 'Denemarken',
                    selectCountry: 'Selecteer land',
                },
                validation: {
                    invalidEmail: 'Ongeldig e-mailadres',
                    nameRequired: 'Naam is verplicht',
                    phoneRequired: 'Telefoonnummer is verplicht',
                    invalidPhone: 'Ongeldig telefoonnummer',
                    addressRequired: 'Adres is verplicht',
                    postalCodeRequired: 'Postcode is verplicht',
                    invalidPostalCode: 'Ongeldige postcode. Voorbeeld: {{example}}',
                    cityRequired: 'Plaats is verplicht',
                    selectCountry: 'Selecteer een geldig land',
                },
                voucher: {
                    types: {
                        Smeedcursussen: 'Smeedcursussen',
                        'Cursus messen maken': 'Cursus messen maken',
                        'Waardebon eigen bedrag': 'Waardebon eigen bedrag',
                    },
                    from: 'Van',
                    to: 'Voor',
                    amount: 'Bedrag',
                    orderVoucher: 'Waardebon bestellen',
                    customAmount: 'Eigen bedrag',
                    selectVoucher: 'Stel uw waardebon samen',
                    successMessage: 'Waardebon succesvol toegevoegd aan je winkelwagen!',
                    viewCart: 'Bekijk winkelwagen',
                    addAnother: 'Nog een waardebon toevoegen',
                    enterAmount: 'Voer bedrag in',
                    prefix: 'Waardebon: {{description}}',
                    noTicketsAvailable: 'Geen tickets meer beschikbaar',
                    increaseQuantity: 'Verhoog aantal',
                    description_for_customized_vouchers:
                        'Je kunt een waardebon kopen voor een ander of voor jezelf. Vul hieronder de gegevens in.',
                    title: 'Waardebon',
                    enterCode: 'Voer waardeboncode in',
                    apply: 'Toepassen',
                    remove: 'Verwijderen',
                    invalid: 'Ongeldige waardeboncode',
                    applied: 'Waardebon succesvol toegepast',
                    removed: 'Waardebon verwijderd',
                    applyFailed: 'Fout bij toepassen waardebon',
                    removalFailed: 'Fout bij verwijderen waardebon',
                },
            },
        },
        de: {
            translation: {
                calendar: {
                    url: '/kurse/{{year}}/{{month}}',
                    available_one: '{{count}} Freier Platz',
                    available_other: '{{count}} Freie Plätze',
                    available_zero: 'Ausgebucht',
                },
                cart: {
                    soldOut: 'Ausverkauft',
                    lastSpot: 'Letzter Platz',
                    availableTickets: '{{count}} Tickets verfügbar',
                    confirmRemove: 'Möchten Sie diesen Artikel wirklich entfernen?',
                    subtotal: 'Zwischensumme',
                    vat: 'MwSt. (inkl.)',
                    total: 'Gesamtsumme',
                    checkout: 'Zur Kasse',
                    empty: 'Ihr Warenkorb ist leer',
                },
                common: {
                    error: 'Etwas ist schief gelaufen',
                },
                checkout: {
                    orderSummary: 'Bestellübersicht',
                    personalDetails: 'Persönliche Daten',
                    name: 'Name',
                    email: 'E-Mail',
                    address: 'Adresse',
                    postalCode: 'Postleitzahl',
                    city: 'Stadt',
                    country: 'Land',
                    termsAgreement:
                        'Ich stimme den <privacy>Datenschutzbestimmungen</privacy> und den <terms>Allgemeinen Geschäftsbedingungen</terms> zu',
                    pay: 'Bezahlen',
                    phone: 'Telefonnummer der Kontaktperson',
                    phoneHelper:
                        'Ihre Telefonnummer wird für Kontakt und Abstimmung bezüglich des Kurses benötigt.',
                    invalidCountry: 'Dieses Land ist nicht erlaubt',
                    deposit: 'Anzahlung',
                    depositInfo:
                        'Für eine Reservierung ist eine Mindestanzahlung von 50% erforderlich. Der Restbetrag kann bis eine Woche vor dem Kurs per Überweisung bezahlt werden. Der Restbetrag kann auch in bar oder per EC-Karte zu Beginn des Kurses bezahlt werden.',
                    backToCart: 'Zurück zum Warenkorb',
                },
                countries: {
                    NL: 'Niederlande',
                    BE: 'Belgien',
                    DE: 'Deutschland',
                    LU: 'Luxemburg',
                    PL: 'Polen',
                    CH: 'Schweiz',
                    AT: 'Österreich',
                    FR: 'Frankreich',
                    GB: 'Großbritannien',
                    DK: 'Dänemark',
                    selectCountry: 'Land auswählen',
                },
                validation: {
                    invalidEmail: 'Ungültige E-Mail-Adresse',
                    nameRequired: 'Name ist erforderlich',
                    phoneRequired: 'Telefonnummer ist erforderlich',
                    invalidPhone: 'Ungültiges Telefonnummer-Format',
                    addressRequired: 'Adresse ist erforderlich',
                    postalCodeRequired: 'Postleitzahl ist erforderlich',
                    invalidPostalCode: 'Ungültiges Postleitzahl-Format. Beispiel: {{example}}',
                    cityRequired: 'Stadt ist erforderlich',
                    selectCountry: 'Bitte wählen Sie ein gültiges Land',
                },
                voucher: {
                    types: {
                        Smeedcursussen: 'Schmiedekurse',
                        'Cursus messen maken': 'Messermacherkurs',
                        'Waardebon eigen bedrag': 'Gutschein eigener Betrag',
                    },
                    from: 'Von',
                    to: 'Für',
                    amount: 'Betrag',
                    orderVoucher: 'Gutschein bestellen',
                    customAmount: 'Eigener Betrag',
                    selectVoucher: 'Wählen Sie Ihren Gutschein',
                    successMessage: 'Gutschein erfolgreich in den Warenkorb gelegt!',
                    viewCart: 'Zum Warenkorb',
                    addAnother: 'Weiteren Gutschein hinzufügen',
                    enterAmount: 'Betrag eingeben',
                    prefix: 'Gutschein: {{description}}',
                    noTicketsAvailable: 'Keine Tickets mehr verfügbar',
                    increaseQuantity: 'Menge erhöhen',
                    description_for_customized_vouchers:
                        'Sie können einen Gutschein für jemand anderen oder für sich selbst kaufen. Bitte füllen Sie die Details unten aus.',
                    title: 'Gutschein',
                    enterCode: 'Gutscheincode eingeben',
                    apply: 'Einlösen',
                    remove: 'Entfernen',
                    invalid: 'Ungültiger Gutscheincode',
                    applied: 'Gutschein erfolgreich eingelöst',
                    removed: 'Gutschein entfernt',
                    applyFailed: 'Fehler beim Einlösen des Gutscheins',
                    removalFailed: 'Fehler beim Entfernen des Gutscheins',
                },
            },
        },
    },
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
